import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useColors } from './shared';

export default function ContactPage() {
  const c = useColors();
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <Box sx={{ minHeight: '100vh', background: c.bg, py: { xs: 4, md: 8 }, px: { xs: 2, md: 4 } }}>
      <Box sx={{ maxWidth: 800, mx: 'auto' }}>
        <span
          onClick={() => navigate('/')}
          style={{ color: c.accent, fontSize: '0.95rem', cursor: 'pointer', fontFamily: "'Urbanist', sans-serif" }}
        >
          &larr; Back to Destrier
        </span>

        <h1 style={{ fontFamily: "'Urbanist', sans-serif", fontWeight: 800, fontSize: '2.2rem', color: c.textPrimary, margin: '24px 0 8px 0' }}>
          Contact Us
        </h1>
        <p style={{ color: c.textSecondary, fontSize: '1rem', lineHeight: 1.7, margin: '0 0 40px 0', fontFamily: "'Urbanist', sans-serif" }}>
          Have a question, feedback, or a data request? We&rsquo;d love to hear from you.
        </p>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* General */}
          <Box sx={{ p: 3, borderRadius: 2, background: c.bgCard, border: `1px solid ${c.border}` }}>
            <h2 style={{ fontFamily: "'Urbanist', sans-serif", fontWeight: 700, fontSize: '1.2rem', color: c.textPrimary, margin: '0 0 8px 0' }}>General Inquiries</h2>
            <p style={{ color: c.textSecondary, fontSize: '0.95rem', lineHeight: 1.7, margin: 0 }}>
              For questions about Destrier, feature requests, or anything else:
            </p>
            <Box
              component="span"
              onClick={() => navigator.clipboard.writeText('destrierai@gmail.com')}
              sx={{
                display: 'inline-block',
                mt: 1.5,
                px: 2,
                py: 0.8,
                borderRadius: 1.5,
                background: c.accent + '15',
                color: c.accent,
                fontSize: '0.95rem',
                fontWeight: 600,
                fontFamily: "'Urbanist', sans-serif",
                cursor: 'pointer',
                transition: 'background 0.2s ease',
                '&:hover': { background: c.accent + '25' },
              }}
            >
              destrierai@gmail.com — click to copy
            </Box>
          </Box>

          {/* Bug reports */}
          <Box sx={{ p: 3, borderRadius: 2, background: c.bgCard, border: `1px solid ${c.border}` }}>
            <h2 style={{ fontFamily: "'Urbanist', sans-serif", fontWeight: 700, fontSize: '1.2rem', color: c.textPrimary, margin: '0 0 8px 0' }}>Bug Reports</h2>
            <p style={{ color: c.textSecondary, fontSize: '0.95rem', lineHeight: 1.7, margin: 0 }}>
              Found something broken? Let us know by email with a description of what happened and we&rsquo;ll look into it.
            </p>
          </Box>
        </Box>

        {/* Footer */}
        <Box sx={{ mt: 6, pt: 3, borderTop: `1px solid ${c.border}`, textAlign: 'center' }}>
          <p style={{ color: c.textMuted, fontSize: '0.85rem', fontFamily: "'Urbanist', sans-serif" }}>
            &copy; {new Date().getFullYear()} Destrier
          </p>
        </Box>
      </Box>
    </Box>
  );
}
